import axiosInstance from "../../axiosInstance";

const BASE_URL = "/hrm/payroll";

export const getPayrollRuns = async (params = {}) => {
  const res = await axiosInstance.get(`${BASE_URL}/runs`, { params });
  return res.data.records || [];
};

export const getPayrollRunDetail = async (id) => {
  const res = await axiosInstance.get(`${BASE_URL}/runs/${id}`);
  return res.data;
};

export const createPayrollRun = async (payload) => {
  const res = await axiosInstance.post(`${BASE_URL}/runs`, payload);
  return res.data;
};

export const calculatePayrollRun = async (id) => {
  const res = await axiosInstance.post(`${BASE_URL}/runs/${id}/calculate`);
  return res.data;
};

export const updatePayrollPayslip = async (runId, payslipId, payload) => {
  const res = await axiosInstance.patch(`${BASE_URL}/runs/${runId}/payslips/${payslipId}`, payload);
  return res.data;
};

export const submitPayrollRun = async (id) => {
  const res = await axiosInstance.patch(`${BASE_URL}/runs/${id}/submit`);
  return res.data;
};

export const approvePayrollRun = async (id, payload = {}) => {
  const res = await axiosInstance.patch(`${BASE_URL}/runs/${id}/approve`, payload);
  return res.data;
};

export const rejectPayrollRun = async (id, reject_reason) => {
  const res = await axiosInstance.patch(`${BASE_URL}/runs/${id}/reject`, { reject_reason });
  return res.data;
};

export const publishPayrollRun = async (id) => {
  const res = await axiosInstance.patch(`${BASE_URL}/runs/${id}/publish`);
  return res.data;
};

export const getMyPayslips = async () => {
  const res = await axiosInstance.get(`${BASE_URL}/my-payslips`);
  return res.data.records || [];
};
